var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99399 16.25C6.54627 16.25 6.99399 15.8023 6.99399 15.25C6.99399 12.4886 9.23256 10.25 11.994 10.25C14.7554 10.25 16.994 12.4886 16.994 15.25C16.994 15.8023 17.4417 16.25 17.994 16.25C18.5463 16.25 18.994 15.8023 18.994 15.25C18.994 11.384 15.86 8.25 11.994 8.25C8.12799 8.25 4.99399 11.384 4.99399 15.25C4.99399 15.5152 5.09934 15.7696 5.28688 15.9571C5.47442 16.1446 5.72877 16.25 5.99399 16.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74399 16.25H3.24399C3.79627 16.25 4.24399 15.8023 4.24399 15.25C4.24399 14.6977 3.79627 14.25 3.24399 14.25H1.74399C1.1917 14.25 0.743988 14.6977 0.743988 15.25C0.743988 15.8023 1.1917 16.25 1.74399 16.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09999 9.77C5.49237 10.149 6.11607 10.1436 6.50181 9.75782C6.88754 9.37209 6.89296 8.74838 6.51399 8.356L5.45299 7.3C5.20719 7.02071 4.82664 6.90096 4.4652 6.98918C4.10375 7.07739 3.82116 7.35898 3.73166 7.72012C3.64217 8.08125 3.76056 8.46221 4.03899 8.709L5.09999 9.77Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.994 7.5C12.5463 7.5 12.994 7.05228 12.994 6.5V5C12.994 4.44772 12.5463 4 11.994 4C11.4417 4 10.994 4.44772 10.994 5V6.5C10.994 7.05228 11.4417 7.5 11.994 7.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.744 15.25C19.744 15.8023 20.1917 16.25 20.744 16.25H22.244C22.7963 16.25 23.244 15.8023 23.244 15.25C23.244 14.6977 22.7963 14.25 22.244 14.25H20.744C20.1917 14.25 19.744 14.6977 19.744 15.25Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.182 10.063C18.4472 10.0629 18.7015 9.95755 18.889 9.77L19.949 8.709C20.2274 8.46221 20.3458 8.08125 20.2563 7.72012C20.1668 7.35898 19.8842 7.07739 19.5228 6.98918C19.1613 6.90096 18.7808 7.02071 18.535 7.3L17.475 8.361C17.1891 8.647 17.1036 9.07704 17.2583 9.45066C17.4131 9.82428 17.7776 10.0679 18.182 10.068V10.063Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.994 18H1.00601C0.453727 18 0.00601196 18.4477 0.00601196 19C0.00601196 19.5523 0.453727 20 1.00601 20H22.994C23.5463 20 23.994 19.5523 23.994 19C23.994 18.4477 23.5463 18 22.994 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunset);
export default __webpack_public_path__ + "static/media/sunset.dd8215d1.svg";
export { ForwardRef as ReactComponent };